import {NgModule} from '@angular/core';
import {
  CategoriaAdminComponent,
  CategoriaEditComponent,
  CategoriaNewComponent,
  SubcategoriaAdminComponent, SubcategoriaEditComponent, SubcategoriaNewComponent
} from './components/admin/categoria.admin.component';
import {CommonModule, DecimalPipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {RvgRoutingModule} from './rvg.routing.module';
import {CategoriasServices} from './services/categorias.services';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {PreguntasServices} from './services/preguntas.services';
import {PreguntasAdminComponent, PreguntasEditComponent, PreguntasNewComponent} from './components/admin/preguntas.admin.component';
import {PlantillasServices} from './services/plantillas.services';
import {PlantillaEditComponent, PlantillaNewComponent, PlantillasAdminComponent} from './components/admin/plantillas.admin.component';
import {VisitaAdminComponent} from './components/admin/visita.admin.component';
import {VisitaServices} from './services/visita.services';
import {ListVisitasComponent, EditVisitaComponent, VisitaComponent} from './components/visita.component';
import {AlertModule, TabsModule} from 'ngx-bootstrap';
import {ResultadoServices} from './services/resultado.services';
import {RespuestaComponent} from './components/respuesta.component';
import {RvgSecurityServices} from './services/rvg.security.services';

// import {LightboxModule} from 'ngx-lightbox';

@NgModule({
  declarations: [
    CategoriaAdminComponent,
    CategoriaEditComponent,
    CategoriaNewComponent,
    SubcategoriaAdminComponent,
    SubcategoriaEditComponent,
    SubcategoriaNewComponent,
    PreguntasAdminComponent,
    PreguntasNewComponent,
    PreguntasEditComponent,
    PlantillasAdminComponent,
    PlantillaEditComponent,
    PlantillaNewComponent,
    VisitaAdminComponent,
    VisitaComponent,
    EditVisitaComponent,
    ListVisitasComponent,
    RespuestaComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    RvgRoutingModule,
    NgxDatatableModule,
    TabsModule.forRoot(),
    AlertModule
  ],
  providers: [
    CategoriasServices,
    PreguntasServices,
    PlantillasServices,
    VisitaServices,
    ResultadoServices,
    RvgSecurityServices,
    DecimalPipe
  ]
})
export class RvgModule {

}
